"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionAssetEntityFactory = exports.CollectionAssetFactory = exports.CollectionFactory = exports.PageableCollectionsEntityFactory = exports.getFilteredCollectionsQuery = exports.CollectionEntityFactory = void 0;
const LinkEntity_1 = require("../sub-clients/common/model/LinkEntity");
require("urijs/src/URITemplate");
const expandUrlTemplate_1 = __importDefault(require("../sub-clients/common/utils/expandUrlTemplate"));
const CollectionPermissions_1 = require("../sub-clients/collections/model/CollectionPermissions");
const VideosEntityFactory_1 = require("./VideosEntityFactory");
const VideosFactory_1 = require("./VideosFactory");
class CollectionEntityFactory {
    static sample(collection) {
        const id = '123';
        const defaults = {
            id,
            owner: 'owner-id',
            ownerName: 'Owner Name',
            title: 'My Videos edited',
            assets: [],
            updatedAt: '2019-10-21T09:11:19.074Z',
            discoverable: false,
            promotedFor: [],
            mine: false,
            createdBy: 'Teacher',
            subjects: [],
            ageRange: null,
            description: null,
            permissions: { anyone: CollectionPermissions_1.CollectionPermission.VIEW_ONLY },
            attachments: [],
            _links: {
                self: {
                    href: `/v1/collections/${id}`,
                },
                edit: {
                    href: `/v1/collections/${id}/edit`,
                },
                safeEdit: {
                    href: `/v1/collections/${id}?last_updated_at=2022-12-06T14%3A35%3A21.123%2B01%3A00`,
                },
                bookmark: {
                    href: `/v1/collections/${id}/bookmark`,
                },
            },
        };
        return {
            ...defaults,
            ...collection,
        };
    }
}
exports.CollectionEntityFactory = CollectionEntityFactory;
const getFilteredCollectionsQuery = (filters, projection, types, bookmarked) => {
    const { query, partialTitleMatch, page, size, canEdit, ignore_discoverable } = filters;
    const uri = (0, expandUrlTemplate_1.default)('/collections{?bookmarked,types,query,partial_title_match,subject,projection,page,size,can_edit,ignore_discoverable}', {
        bookmarked: bookmarked,
        types: types,
        query: query,
        partial_title_match: partialTitleMatch,
        page,
        size,
        projection,
        can_edit: canEdit,
        ignore_discoverable,
    });
    return uri.split('?')[1];
};
exports.getFilteredCollectionsQuery = getFilteredCollectionsQuery;
class PageableCollectionsEntityFactory {
    static sample(filters = { page: 0, size: 25 }, collections = [], projection = 'details') {
        const { page, size } = filters;
        const sizeOrDefault = size ? size : 0;
        const projectionOrDefault = projection ? projection : 'details';
        return {
            page: {
                number: page ? page : 0,
                size: sizeOrDefault,
                totalElements: collections.length,
                totalPages: Math.floor(collections.length / sizeOrDefault),
            },
            _embedded: { collections },
            _links: {
                details: {
                    href: `/v1/collections?${(0, exports.getFilteredCollectionsQuery)(filters, 'details')}`,
                },
                list: {
                    href: `/v1/collections?${(0, exports.getFilteredCollectionsQuery)(filters, 'list')}`,
                },
                next: {
                    href: `/v1/collections?${(0, exports.getFilteredCollectionsQuery)(filters, projectionOrDefault)}`,
                },
                self: {
                    href: `/v1/collections?${(0, exports.getFilteredCollectionsQuery)(filters, projectionOrDefault)}`,
                },
            },
        };
    }
}
exports.PageableCollectionsEntityFactory = PageableCollectionsEntityFactory;
class CollectionFactory {
    static defaultFields() {
        const id = '123';
        return {
            id,
            owner: 'owner-id',
            ownerName: 'Owner Name',
            title: 'My Videos edited',
            assets: [],
            updatedAt: new Date('2019-10-21T09:11:19.074Z'),
            discoverable: false,
            mine: false,
            createdBy: 'Teacher',
            subjects: [],
            ageRange: null,
            description: undefined,
            attachments: [],
            permissions: { anyone: CollectionPermissions_1.CollectionPermission.VIEW_ONLY },
            links: {
                self: new LinkEntity_1.Link({
                    href: `/v1/collections/${id}`,
                }),
                addVideo: new LinkEntity_1.Link({
                    href: `/v1/collections/${id}/videos/{video_id}`,
                }),
                safeEdit: new LinkEntity_1.Link({
                    href: `/v1/collections/${id}?last_updated_at=2022-12-06T14%3A35%3A21.123%2B01%3A00`,
                }),
                removeVideo: new LinkEntity_1.Link({
                    href: `/v1/collections/${id}/videos/{video_id}`,
                }),
                addComment: new LinkEntity_1.Link({
                    href: `/v1/collections/${id}/comments`,
                }),
                removeComment: new LinkEntity_1.Link({
                    href: `/v1/collections/${id}/comments/{comment_id}`,
                }),
            },
        };
    }
}
exports.CollectionFactory = CollectionFactory;
CollectionFactory.sampleFromId = (collection = { id: '123' }) => {
    const id = collection.id;
    return {
        ...CollectionFactory.defaultFields(),
        id,
        links: {
            self: new LinkEntity_1.Link({
                href: `/v1/collections/${id}`,
            }),
        },
    };
};
CollectionFactory.sample = (collection) => ({
    ...CollectionFactory.defaultFields(),
    ...collection,
});
CollectionFactory.sampleCollectionLinks = (links) => ({
    ...CollectionFactory.defaultFields().links,
    ...links,
});
class CollectionAssetFactory {
    static defaultFields() {
        return {
            id: { videoId: 'video-id', highlightId: null },
            video: VideosFactory_1.VideoWithBoclipsProjectionFactory.sample({ id: 'video-id' }),
            comments: [],
        };
    }
}
exports.CollectionAssetFactory = CollectionAssetFactory;
CollectionAssetFactory.sample = (collectionAsset) => ({
    ...CollectionAssetFactory.defaultFields(),
    ...collectionAsset,
});
class CollectionAssetEntityFactory {
    static defaultFields() {
        return {
            id: { videoId: 'video-id', highlightId: null },
            video: VideosEntityFactory_1.VideosEntityFactory.sample({ id: 'video-id' }),
            comments: [],
        };
    }
}
exports.CollectionAssetEntityFactory = CollectionAssetEntityFactory;
CollectionAssetEntityFactory.sample = (collectionAsset) => ({
    ...CollectionAssetEntityFactory.defaultFields(),
    ...collectionAsset,
});
//# sourceMappingURL=CollectionsFactory.js.map